import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

/**
 * A single flag gates every Similar Item Alerts surface (ended-lot PDP CTA, Price Results CTA,
 * For You tab, Emails & Notifications section): treatment shows the feature, control shows nothing.
 * Resolve this hook from an always-evaluated point on the qualifying page — not inside the
 * treatment-only render — so Amplitude exposure fires for control users too.
 */
export const useSimilarItemAlertsExperiment = () =>
    useAmplitudeExperimentBase(AmplitudeExperiments.SimilarItemAlerts, AmplitudeVariants.SimilarItemAlerts.Treatment);
